<template>
  <div class="group-status-cell">
    <group-status-chip v-if="hasChip" :group="group" />
    <button
      v-if="actionLabel"
      type="button"
      class="cooked-weights-button cooked-weights-button--outline group-status-cell__action"
      @click.stop="$emit('open')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<script>
import GroupStatusChip from './GroupStatusChip.vue'
import { describeGroupAction, hasStatusChip } from '../groupStatus'

export default {
  name: 'GroupStatusCell',
  components: {
    GroupStatusChip
  },
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasChip () {
      return hasStatusChip(this.group)
    },
    actionLabel () {
      return describeGroupAction(this.group)
    }
  }
}
</script>

<style scoped>
.group-status-cell {
  display: flex;
  align-items: center;
  gap: 8px 12px;
}

.group-status-cell__action {
  margin-left: auto;
}
</style>
